
import { FovTypography } from 'components';
import { DeleteOutlined } from 'components/icons';
import { IconButton, NameContainer } from 'pages/ArchVisionAdminDashboard/styles';
import constants from 'constants/index';

const light = constants.THEME.LIGHT;

export const listColumns = () => ([
    {
        title: 'Instance Name',
        key: 'name',
        width: 300,
        alignContent: 'left',
        render: (text, pipeline) => {
            return (
                <NameContainer>
                    <div>{pipeline.instanceName}</div>
                    <div>{pipeline.instanceId}</div>
                </NameContainer>
            );
        },
    },
    {
        title: 'Instance ID',
        key: 'instance_id',
        width: 100,
        render: (text, pipeline) => (
            <FovTypography>{pipeline.instanceId}</FovTypography>
        ),
    },
    {
        title: 'CPU Usage',
        key: 'datapoint',
        render: (text, pipeline) => {
            const average = pipeline.dataPoints[0].Average;
            return (
                <FovTypography>{average.toFixed(2)}%</FovTypography>
            );
        },
    },

]);

export const queueListColumns = (theme, selectedTheme, setShowQueueFlush, setSelectedQueue) => ([
    {
        title: 'Queue Name',
        key: 'queue_name',
        width: 300,
        alignContent: 'left',
        render: (text, queue) => (
            <NameContainer>
                <div>{queue.queueName}</div>
            </NameContainer>
        ),
    },
    {
        title: 'Message Count',
        key: 'message_count',
        render: (text, queue) => (
            <FovTypography>{queue.data.ApproximateNumberOfMessages}</FovTypography>
        ),
    },
    {
        title: 'Actions',
        key: 'actions',
        width: 50,
        alignContent: 'center',
        render: (text, queue) => (
            <IconButton
                theme={theme}
                $selectedTheme={selectedTheme}
                onClick={() => {
                    setShowQueueFlush(true);
                    setSelectedQueue(queue.queueName);
                }}
                icon={
                    <DeleteOutlined
                        color={theme.colors[selectedTheme][selectedTheme === light ? 'darkGrey' : 'lightGrey']}
                        hoverColor={theme.colors[selectedTheme][selectedTheme === light ? 'darkGrey' : 'lightGrey']}
                    />
                }
            />
        ),
    },
]);
